/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import { useState, useEffect } from 'react';
import '../../_chunks/dep-2acfafca.js';

var checkImages = function checkImages(images) {
  return images.map(function (image) {
    var result = {
      mainImage: ""
    };
    if (typeof image === "string" || !image) result.mainImage = image;else {
      result.mainImage = image.mainImage;
      result.thumbnail = image.thumbnail;
      result.download = image.download;
    }
    return result;
  });
};
var useList = function useList(images) {
  var _useState = useState(function () {
      return checkImages(images);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    list = _useState2[0],
    setList = _useState2[1];
  useEffect(function () {
    setList(checkImages(images));
  }, [images]);
  return list;
};

export { useList as default };
//# sourceMappingURL=useList.js.map
